import type { FlowCopy } from "./content.js";
import { MenuIcon } from "./icons.js";
import { pad } from "./scroll-steps.js";

export interface StepRailProps {
  readonly labels: readonly string[];
  readonly step: number;
  go(index: number): void;
}

export function StepRail({ labels, step, go }: StepRailProps) {
  return (
    <div class="flow-rail" data-testid="flow-rail">
      {labels.map((label, index) => (
        <button
          key={`${index}-${label}`}
          type="button"
          class={`flow-rail-step${index < step ? " is-done" : ""}${index === step ? " is-on" : ""}`}
          aria-label={`${pad(index + 1)} ${label}`}
          aria-pressed={index === step}
          onClick={() => go(index)}
        >
          <span class="flow-rail-text">
            <b>{pad(index + 1)}</b>
            <small>{label}</small>
          </span>
          <span class="flow-rail-bar" />
        </button>
      ))}
      <span class="flow-rail-down" aria-hidden="true">
        <MenuIcon name="chevron" size={18} />
      </span>
    </div>
  );
}

export function SnapStops({ total }: { readonly total: number }) {
  return (
    <>
      {Array.from({ length: total }, (_, index) => (
        <span key={index} class="flow-snap" style={{ "--i": index }} aria-hidden="true" />
      ))}
    </>
  );
}

export function stepOf(template: string, step: number, total: number): string {
  return template.replace("{n}", String(step + 1)).replace("{total}", String(total));
}

export interface ScrollCueProps {
  readonly copy: Pick<FlowCopy, "scrollNext" | "nudgeLast" | "stepOf">;
  readonly step: number;
  readonly total: number;
  readonly shown: boolean;
  next(): void;
}

export function ScrollCue({ copy, step, total, shown, next }: ScrollCueProps) {
  return (
    <button
      type="button"
      class={shown ? "flow-cue is-on" : "flow-cue"}
      onClick={next}
      tabIndex={shown ? 0 : -1}
      aria-hidden={!shown}
      data-testid="flow-cue"
    >
      <span class="flow-mouse" aria-hidden="true">
        <i />
      </span>
      {step < total - 1 ? copy.scrollNext : copy.nudgeLast}
      <span class="flow-cue-count">{stepOf(copy.stepOf, step, total)}</span>
    </button>
  );
}
